import ContractSignScreen from '@/components/contract-sign';

export default ContractSignScreen;
